// extracted by mini-css-extract-plugin
export default {"errorContainer":"styles_errorContainer__Qus2f","errorImage":"styles_errorImage__PdZZH","errorTitle":"styles_errorTitle__m-xmt","errorSubtitle":"styles_errorSubtitle__cEBWS"};